
import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const AquaFirme = () => {
  const treatmentData = {
    title: "AquaFirme Facial",
    subtitle: "Deep hydration and instant glow with zero downtime",
    description: "Our signature AquaFirme facial combines gentle exfoliation, deep cleansing, and intense hydration for instantly radiant skin. Perfect for all skin types with immediate, glowing results.",
    whoItsFor: [
      "Anyone wanting immediate skin radiance",
      "Those with dehydrated or dull skin",
      "People preparing for special events",
      "Clients seeking gentle, effective treatment",
      "Anyone new to professional skincare"
    ],
    packages: [
      {
        name: "Single AquaFirme",
        visitorPrice: "$250",
        memberPrice: "$225",
        description: "Complete hydrating facial treatment"
      },
      {
        name: "Glow Series",
        visitorPrice: "$650",
        memberPrice: "$585",
        description: "Package of 3 treatments for lasting results"
      },
      {
        name: "Express Glow",
        visitorPrice: "$150",
        memberPrice: "$135",
        description: "30-minute express version for busy schedules"
      }
    ],
    beforeCare: [
      "Avoid retinoids 24 hours prior",
      "Come with clean, makeup-free face",
      "Stay hydrated",
      "Avoid sun exposure day of treatment"
    ],
    duringCare: [
      "Gentle cleansing and exfoliation",
      "Hydrating serum infusion",
      "45-60 minute relaxing treatment",
      "LED light therapy included"
    ],
    afterCare: [
      "Apply SPF 30+ immediately after",
      "Avoid harsh products for 24 hours",
      "Keep skin moisturized",
      "Results visible immediately"
    ],
    memberPerks: [
      "10% discount on all AquaFirme treatments",
      "Complimentary take-home skincare sample",
      "Priority booking for monthly maintenance",
      "Free skin analysis with every treatment",
      "Exclusive member-only add-on services"
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default AquaFirme;
